import React, { useContext, useEffect, useState } from "react";
import Select from "../../Components/FormControl/Select/Select";
import styles from "./index.module.scss";
// Context
import { AppContext } from "../../Context/AppContext";
import { getAccessByModuleName } from "../../Routes/Routes";
import { MODULES } from "../../Helpers/Constants";
// Services
import { getRolloverTimeInfo, rolloverTimeUpdate } from "../../api/settings";
import { convertDateTime } from "Helpers/date";
import moment from "moment";

const RolloverTime = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const [rollOverData, setRollOverData] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [access, setAccess] = useState({});

  useEffect(() => {
    handleRolloverTimeSetting();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.CONFIG_STORE_SETTING);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      window.location.href = "/dashboard";
    }
  }

  const handleManageRolloverTimeMer = async (id, mer) => {
    let rollOverDataObj = await rollOverData.map((rdata) => {
      if (rdata.id === id) {
        rdata.meridiem = mer === "PM" ? "AM" : "PM";
      }
      return rdata;
    });
    setRollOverData(rollOverDataObj);
    handleUpdateRolloverTime(id);
  };

  const handleManageRolloverTimeHrs = async (id, hrs) => {
    let rollOverDataObj = await rollOverData.map((rdata) => {
      if (rdata.id === id) {
        rdata.hrs = hrs;
      }
      return rdata;
    });
    setRollOverData(rollOverDataObj);
    handleUpdateRolloverTime(id);
  };

  const handleManageRolloverTimeMin = async (id, min) => {
    let rollOverDataObj = await rollOverData.map((rdata) => {
      if (rdata.id === id) {
        rdata.min = min;
      }
      return rdata;
    });
    setRollOverData(rollOverDataObj);
    handleUpdateRolloverTime(id);
  };

  const handleRolloverTimeSetting = async () => {
    let response = await getRolloverTimeInfo();

    if (response && response.status === 200) {
      let rollOver = response.data.data;
      let rollOverDataObj = await rollOver.map((rdata) => {
        let time = rdata.value;

        time = time.split(":");
        let ampm = rdata.value.split(" ");
        rdata["hrs"] = time[0];
        if (rdata["hrs"].length === 1) rdata["hrs"] = "0" + rdata["hrs"];
        rdata["min"] = time[1];
        // rdata["meridiem"] =
        //   rdata["hrs"] >= "05" && rdata["min"] > "00" && ampm[1] === "AM"
        //     ? "PM"
        //     : ampm[1];
        rdata["meridiem"] = ampm[1];
        let twentyFourFormat = moment(rdata["hrs"]+":"+rdata["min"], "HH:mm").format("hh:mm A");

        // Use a fixed date (2026-01-01) to avoid DST-dependent UTC offsets for non-DST zones
        let commonDateTimeConvert = convertDateTime("20260101 " + twentyFourFormat, "format7temp", "yyyyMMdd hh:mm a")

        rdata["hrs"] = commonDateTimeConvert.toFormat("hh");
        rdata["min"] = commonDateTimeConvert.toFormat("mm");
        rdata["meridiem"] = commonDateTimeConvert.toFormat("a");
        return rdata;
      });
      setRollOverData(rollOverDataObj);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
  };

  const handleUpdateRolloverTime = async (id) => {
    if (access.write_access) {
      setSubmitStatus(true);
      if (rollOverData && rollOverData.length > 0) {
        let selectedObjData = await rollOverData.filter((d) => d.id === id);
        selectedObjData[0].hrs =
          selectedObjData[0].hrs.length === 1
            ? "0" + selectedObjData[0].hrs
            : selectedObjData[0].hrs;
        // selectedObjData[0].hrs = selectedObjData[0].hrs;

        // selectedObjData[0].meridiem =
        //   selectedObjData[0] >= "05" &&
        //   selectedObjData[0].min > "00" &&
        //   selectedObjData[0].meridiem === "PM"
        //     ? "AM"
        //     : selectedObjData[0].meridiem;

        // selectedObjData[0].hrs =
        //   parseFloat(selectedObjData[0].hrs) + parseFloat(7);
        selectedObjData[0]["value"] =
          selectedObjData[0].hrs +
          ":" +
          selectedObjData[0].min +
          ":00 " +
          selectedObjData[0].meridiem;
        if (selectedObjData) {
          let requestBody = selectedObjData[0];
          let response = await rolloverTimeUpdate(requestBody);

          if (response && response.status === 200) {
            setSubmitStatus(false);
            handleRolloverTimeSetting();
          } else {
            showToastMessage(undefined, response.data.message, "error", false);
          }
        }
      }
    } else {
      showToastMessage(
        undefined,
        "You are not authorized to update this setting.",
        "error",
        false
      );
    }
  };

  // 			});


  return (
    <React.Fragment>
      {rollOverData.map((r) => (
        <div
          key={r.id}
          className={`align-items-md-center mt-5 mb-1 ${styles.rollOver}`}
        >
          <h3 style={{ flexBasis: "30%" }}>{r.key}</h3>

          <div className={styles.selectItme}>
            <Select // parentClass="text-left" value={value}
              required={true}
              submitStatus={submitStatus}
              value={r.hrs}
              onChange={(data) => handleManageRolloverTimeHrs(r.id, data)}
              options={[
                { id: "01", title: "01" },
                { id: "02", title: "02" },
                { id: "03", title: "03" },
                { id: "04", title: "04" },
                { id: "05", title: "05" },
                { id: "06", title: "06" },
                { id: "07", title: "07" },
                { id: "08", title: "08" },
                { id: "09", title: "09" },
                { id: "10", title: "10" },
                { id: "11", title: "11" },
                { id: "12", title: "12" },
              ]}
              disabled={false}
            />
          </div>
          <div className={styles.selectItme2}>
            <Select
              parentClass="text-left"
              required={true}
              submitStatus={submitStatus}
              onChange={(data) => handleManageRolloverTimeMin(r.id, data)}
              value={r.min}
              options={[
                { id: "00", title: "00" },
                { id: "15", title: "15" },
                { id: "30", title: "30" },
                { id: "45", title: "45" },
              ]}
              disabled={false}
            />
          </div>
          <div className={`d-block text-left ${styles.changeButton}`}>
            <button
              onClick={(e) => handleManageRolloverTimeMer(r.id, r.meridiem)}
              className="btn pink-btn bold"
            >
              {r.meridiem}
            </button>
          </div>
        </div>
      ))}
    </React.Fragment>
  );
};
export default RolloverTime;
